import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import ConversationFactory from "../../Entity/Factories/ConversationFactory";

export default function* conversationForConversationDetailsPage(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, `conversations/${action.payload?.conversationId}`);

    const conversation = ConversationFactory.create(res.data);

    yield put({
      type: Constants.GLOBAL_CONVERSATION_UPDATE_SUCCESS,
      payload: {
        conversation: conversation
      }
    });

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this, conversation);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CONVERSATION_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchConversationForConversationDetailsPage() {
  yield takeEvery(Constants.GLOBAL_CONVERSATION_FOR_CONVERSATION_DETAILS_PAGE, conversationForConversationDetailsPage);
}
